// @mui material components
import { Grid, Card } from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Footer from "examples/Footer";

// Material Dashboard 2 React context
import { useMaterialUIController } from "context";

// Import projects data
import Projects from "layouts/orders/components/Projects";

function Orders() {
  const [controller] = useMaterialUIController();
  const { currentStudy } = controller;

  const studyTitle = currentStudy === undefined ? "" : currentStudy.replace(/_/g, " ");

  return (
    <DashboardLayout>
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12} sm={6} md={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  {studyTitle} Orders
                </MDTypography>
              </MDBox>
              <MDBox pt={3}>
                <Projects />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Orders;
